import React, { useEffect, useState } from "react";
import Pagination from "../../pagination";
import queryString from "query-string";
import DeleteModal from "../../modal/delete-modal";
import AdminFilterDrawer from "../../../components/filter/admin-filter-drawer";
import { useRole } from "../../../context/role/RoleContext";
import { Link, useLocation, useParams } from "react-router-dom";
import { api } from "../../../redux/apis/api";
import Loader from "../../../assets/icons/loader/loader";
import CustomerPaymentCreateModal from "./customer-payment-create-modal";
import CustomerPaymentEditModal from "./customer-payment-edit-modal";
import CustomerPaymentViewModal from "./customer-payment-view-modal";

const CustomerPaymentList = ({ activeTab }) => {
  const location = useLocation();
  const params = useParams();
  const { state } = useRole();
  const permission = state?.role?.payment;
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");
  const [createModal, setcreateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectID, setSelectID] = useState("");

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    api
      .post(`/payment/list`, {
        page: page_no,
        customer_id: params?.id,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  useEffect(() => {
    fetchData();
  }, [page_no, location.search]);

  const deleteFnc = (id) => {
    api
      .post(`/payment/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const filterInputs = [
    {
      label: "Status",
      type: "dropdown",
      name: "status",
      options: [
        {
          label: "Received",
          value: "received",
        },
        {
          label: "Not received",
          value: "not_received",
        },
        {
          label: "Sent for clearing",
          value: "sent_for_clearing",
        },
        {
          label: "Cleared",
          value: "cleared",
        },
        {
          label: "Rejected",
          value: "rejected",
        },
        {
          label: "Received cheque",
          value: "received_cheque",
        },
        {
          label: "Refunded",
          value: "refunded",
        },
      ],
    },
    {
      label: "created At",
      type: "date",
      name: "createdAt",
    },
    {
      label: "updated At",
      type: "date",
      name: "updatedAt",
    },
  ];

  const searchParams = new URLSearchParams(location.search);
  searchParams.delete("page");
  const filters = searchParams.toString() ? `&${searchParams.toString()}` : "";

  return (
    <div className="h-full">
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />
      <CustomerPaymentCreateModal
        isOpen={createModal}
        onClose={() => {
          setcreateModal(false);
        }}
        listFnc={fetchData}
        customer_id={params?.id}
      />
      <CustomerPaymentEditModal
        selectID={selectID}
        isOpen={editModal}
        onClose={() => {
          setEditModal(false);
        }}
        listFnc={fetchData}
      />
      <CustomerPaymentViewModal
        selectID={selectID}
        isOpen={viewModal}
        onClose={() => {
          setViewModal(false);
        }}
        deleteDisable={permission?.write}
        listFnc={fetchData}
      />
      <section className="h-full">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-xl font-semibold capitalize">payment List</h2>
          <div className="flex gap-2 relative">
            <AdminFilterDrawer
              filterInputs={filterInputs}
              open={filterDrawerOpen}
              onClose={() => setFilterDrawerOpen(false)}
              queryParamsData={queryParamsData}
              activeTab={activeTab}
            />
            {permission?.write && (
              <button
                type="button"
                className="px-4 py-2 bg-blue-600 text-white rounded"
                onClick={() => {
                  setcreateModal(true);
                }}
              >
                Create
              </button>
            )}
            <button
              onClick={() => setFilterDrawerOpen(true)}
              className="px-4 py-1 bg-secondary text-white rounded"
            >
              Filters
            </button>
          </div>
        </div>
        <section className="h-full flex flex-col justify-between overflow-auto">
          <div className="w-full max-w-[82.2vw]  overflow-auto h-full">
            <div className="relative overflow-x-auto">
              <table className="w-full text-left rtl:text-right border border-gray-200">
                <thead className="text-gray-700 uppercase">
                  <tr>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      id
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      payment mode
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      status
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td rowSpan={1}>
                        <div className="w-full flex justify-center py-5">
                          <div className="h-[100px] w-[100px]">
                            <Loader />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {data.rows?.length ? (
                        <>
                          {data.rows.map((row, index) => {
                            return (
                              <tr key={index} className="border-t bg-white">
                                <td className="p-1 px-2">{row?.id ?? "--"}</td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.payment_mode ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.status ?? "--"}
                                  </span>
                                </td>
                                {row?.assignedTo ? (
                                  <td className="py-2 sticky right-0 z-10">
                                    <div className="flex gap-3 bg-white px-4">
                                      {row?.assignedTo?.read && (
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setViewModal(true);
                                            setSelectID(row["id"]);
                                          }}
                                          className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                        >
                                          View
                                        </button>
                                      )}
                                      {row?.assignedTo?.write && (
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setEditModal(true);
                                            setSelectID(row["id"]);
                                          }}
                                          className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                        >
                                          Edit
                                        </button>
                                      )}
                                      {row?.assignedTo?.write && (
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setdeleteModalShow(true);
                                            setSelectDelete(row["id"]);
                                          }}
                                          className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                        >
                                          Delete
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                ) : (
                                  <td className="py-2 sticky right-0 z-10">
                                    <div className="flex gap-3 bg-white px-4">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          setViewModal(true);
                                          setSelectID(row["id"]);
                                        }}
                                        className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                      >
                                        View
                                      </button>
                                      {permission?.write && (
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setEditModal(true);
                                            setSelectID(row["id"]);
                                          }}
                                          className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                        >
                                          Edit
                                        </button>
                                      )}
                                      {permission?.write && (
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setdeleteModalShow(true);
                                            setSelectDelete(row["id"]);
                                          }}
                                          className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                        >
                                          Delete
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td>
                            <p className="text-center my-5">No data found</p>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </section>
      <div
        className={`${
          loading === true ? "pointer-events-none opacity-45" : ""
        }`}
      >
        <Pagination
          totalPages={parseInt(data?.count) ?? 0}
          pagination={parseInt(data?.page) ?? 0}
          path={`/customer/view/${params?.id}`}
          filters={filters}
        />
      </div>
    </div>
  );
};

export default CustomerPaymentList;
